import React from "react";
import { DarkDashboardEmptyIcon, LightDashboardEmptyIcon } from "~/assets/svg/DashboardIcon";
import { useGlobalStore } from "~/store";

const Empty = ({ icon = false, message, button, handleAdd }) => {
	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	function IconControl() {
		return icon ? (
			theme === "dark" ? (
				<DarkDashboardEmptyIcon />
			) : (
				<LightDashboardEmptyIcon />
			)
		) : (
			<></>
		);
	}

	return (
		<div className="empty-wrap">
			{IconControl()}
			<p className="desc">{message}</p>
			{button && (
				<button className="btn__outline btn-add" color="primary" onClick={handleAdd}>
					{button}
				</button>
			)}
		</div>
	);
};

export default Empty;
